// ======================================================================
// File Name       : ParticipantList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../../components/TableHead';
import { getItemBoxName, parseDateForDetail } from '../../../utils/index';
import { DEFAULT_DATE_FORMAT } from '../../../constants/index';
import { SELECT_BOX_DATA } from '../../../constants/SelectBoxData';
import * as enterpriseNotificationConstant from '../../../constants/enterpriseNotificationConstant';
import ReduxFormPaging from '../../../components/ReduxFormPaging';
import CustomLink from '../../button/CustomLink';
import * as Path from '../../../constants/PathConstants';
import * as ICON from '../../../constants/IconConstants';

const thead = [
    { title: 'ユーザー名', sortBy: 0 },
    { title: 'ユーザーグループ名', sortBy: null },
    { title: 'ライブ設定数', sortBy: null, width: '10%' },
    { title: 'ライブ参加数', sortBy: null, width: '10%' },
    { title: '操作', sortBy: null, width: 120 },
];

class ParticipantList extends React.Component {
  render() {
    const {
      handleSortState,
      goToDetail,
      participant,
      recordNum,
      getStartEndData,
      handleMouseEnter,
      handleMouseLeave,
    } = this.props;
    let tbody = null;
    if (participant && participant.userList && participant.userList.length) {
      tbody = participant.userList.map((user, index) => {
        const {
          userSecernId,
          userName,
          groupNames,
          liveCount,
          attendedLiveCount,
        } = user;
        const link = Path.PARTICIPANT_DETAIL.replace(':id', userSecernId);
        return (
          <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
            <td>
              {userName}
            </td>
            <td>
              {groupNames}
            </td>
            <td className="text-right">
              {liveCount == null ? 0 : liveCount}
            </td>
            <td className="text-right">
              {attendedLiveCount == null ? 0 : attendedLiveCount}
            </td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail"
                to={link}
                text="詳細を見る"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="userSortType"
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default ParticipantList;
